import FieldaAvailabilityAPI from './service';
import { useFetch } from '../benchmarks/hooks';

export const useFetchFieldsAvailability = () => {
    const fieldaAvailabilityAPI = new FieldaAvailabilityAPI();
    return useFetch(fieldaAvailabilityAPI.getFieldsAvailability, () => true);
};
